/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Import the shim first
import './import-meta-shim';

import '@rails/activestorage'
import '@hotwired/turbo-rails'
import 'channels'
import 'emoji-picker-element'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'trix'
import Rails from "@rails/ujs"

// Start Turbo
// Turbo.start()
// window.Turbo = Turbo

// Import ActionCable channels
import '../channels'

// Explicitly import Stimulus and initialize
import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

// Initialize Stimulus application
const application = Application.start()
// Fix: Use the correct path for controllers
const context = require.context("../controllers", true, /_controller\.(js|ts)$/)
application.load(definitionsFromContext(context))

//React components
import '../components/Conversation'
import '../components/ConversationMobile'
import '../components/CourseCreator'
import '../components/CourseViewer'
import '../components/CourseViewerMobile'
import '../components/Notifications'
import '../components/FileUploader'
import '../components/TrixUploader'
import '../components/CourseInvitations'
import '../components/CompanyInvitations'

import { setRemoveLinksClickHandler } from '../helpers/RemoveLinksClickHandler'
import '../helpers/ScrollableNav'

// Log that the application has loaded
document.addEventListener('DOMContentLoaded', () => {
  console.log('Application loaded with Stimulus:', application)
})

Rails.start()
